import React from "react";
import { takesMoney } from "../utils/takesMoney";
import type { TipCheckout } from "../hooks/useTipCheckout";
import { t } from "../i18n";

// "<DJ> is currently offline" — the dialog a search tap opens while the DJ
// is Offline; Leave a Tip switches to tip mode. Split out of pages/RequestPage.tsx.

type Props = { showOfflineBlock: boolean; setShowOfflineBlock: (v: boolean) => void; displayDj: any; tip: TipCheckout };

export default function OfflineBlockModal({ showOfflineBlock, setShowOfflineBlock, displayDj, tip }: Props) {
  const { setTipMode, setTipAmount } = tip;
  return (
    <>
    {/* Offline block modal */}
    {showOfflineBlock && displayDj && (
      <div
        role="dialog"
        aria-modal="true"
        style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,.7)", backdropFilter: "blur(4px)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
        }}
        onClick={() => setShowOfflineBlock(false)}
      >
        <div
          style={{
            background: "#111827", color: "#fff", border: "1px solid rgba(255,255,255,0.06)",
            borderRadius: 16, padding: 24, width: "min(92vw, 380px)", boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
            textAlign: "center",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <h3 style={{ fontWeight: 700, fontSize: "1.1rem", margin: "0 0 10px" }}>
            {t("offlineBlockModal.nameIsOffline", { name: displayDj.name ?? "" })}
          </h3>
          <p style={{ color: "#9ca3af", fontSize: "0.9rem", lineHeight: 1.5, marginBottom: 20 }}>
            {t("offlineBlockModal.theyReNotAccepting")}
          </p>
          <div style={{ display: "flex", gap: 10 }}>
            {takesMoney(displayDj) && (
              <button
                onClick={() => {
                  setShowOfflineBlock(false);
                  setTipMode(true);
                  setTipAmount("5");
                }}
                style={{
                  flex: 1, padding: "12px 14px", borderRadius: 10,
                  background: "linear-gradient(135deg, #24C961, #16a34a)",
                  color: "#fff", border: "none", cursor: "pointer", fontWeight: 700, fontSize: "0.92rem",
                }}
              >
                {t("offlineBlockModal.leaveATip")}
              </button>
            )}
            <button
              onClick={() => setShowOfflineBlock(false)}
              style={{
                flex: 1, padding: "12px 14px", borderRadius: 10,
                background: "rgba(255,255,255,0.06)", color: "#9ca3af",
                border: "1px solid rgba(255,255,255,0.08)", cursor: "pointer", fontWeight: 700, fontSize: "0.92rem",
              }}
            >
              {t("offlineBlockModal.gotIt")}
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
